import { Form, Input, Row, Col, Switch, Select, InputNumber } from 'antd';
import { useEffect, useRef, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

const WebProductTypeEdit = (props: any) => {
    const apiId = 'webProductType';
    const [form] = Form.useForm();
    const { defaultService } = props;
    const ref = useRef<any>(undefined);

    const [productCategoryData, setProductCategoryData] = useState<any>();

    useEffect(() => {
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'webProductCategory',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setProductCategoryData(res.data);
                }
            });
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        apiId,
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={10}>
                        <Form.Item
                            label="id"
                            name="id">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={14}>
                        <Form.Item
                            label="分类"
                            name="typeName"
                            rules={[{ required: true, message: '产品分类!' }]}>
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={14}>
                        <Form.Item
                            label="大类"
                            name="productCategoryId"
                            rules={[{ required: true, message: '产品大类!' }]}>
                            <Select
                                placeholder="产品大类"
                                showSearch={{ optionFilterProp: 'label' }}
                                options={getList.general2(productCategoryData, { itemName: 'categoryName' })}>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="排序"
                            name="sortBy">
                            <InputNumber />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={true}
                                checkedChildren="启用"
                                unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>

                </Row>
            )
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default WebProductTypeEdit;